export function getCurrentDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // Month is zero-based
    const day = now.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export function format_date(dt) {
    // Split the date string into an array [year, month, day]
    const [year, month, day] = dt?.split('-');

    // Return the date in 'day-month-year' format
    return `${day}-${month}-${year}`;
}